<script>import { setContext } from "svelte";
import {
  componentsContextKey,
  createComponentsContextValue
} from "./contexts";
import Renderer, { defaultComponents } from "./renderer";
import { createParser, nonNullable } from "./utils";
export let md;
export let plugins = [];
let parse;
$:
  parse = createParser(plugins);
const componentsContextValue = createComponentsContextValue({});
$:
  componentsContextValue.set({
    ...defaultComponents,
    ...plugins.map((plugin) => plugin.renderer).filter(nonNullable).reduce((acc, cur) => ({ ...acc, ...cur }), {})
  });
setContext(componentsContextKey, componentsContextValue);
let result;
$:
  result = parse(md);
</script>

<Renderer astNode={result} />
